import React from "react";
import "./Services.scss";

const servicesData = [
  {
    number: "01",
    title: "Canceles de cristal templado",
    description:
      "Diseñamos e instalamos canceles modernos para baño y espacios interiores, combinando estética, funcionalidad y acabados de alta calidad.",
  },
  {
    number: "02",
    title: "Puertas y ventanas de aluminio",
    description:
      "Fabricamos soluciones en aluminio para proyectos residenciales y comerciales con excelente presentación, resistencia y precisión en cada detalle.",
  },
  {
    number: "03",
    title: "Barandales de vidrio",
    description:
      "Creamos barandales elegantes y seguros que aportan amplitud visual, modernidad y un acabado arquitectónico de alto nivel.",
  },
  {
    number: "04",
    title: "Divisiones para oficina",
    description:
      "Desarrollamos divisiones de cristal para oficinas, corporativos y negocios que buscan espacios funcionales, sobrios y profesionales.",
  },
  {
    number: "05",
    title: "Fachadas y cerramientos",
    description:
      "Realizamos proyectos en vidrio y aluminio para exteriores con soluciones modernas que elevan la imagen del inmueble y mejoran su presencia.",
  },
  {
    number: "06",
    title: "Proyectos especiales a medida",
    description:
      "Atendemos requerimientos personalizados en cristal templado y aluminio para casas, oficinas, comercios y desarrollos de mayor escala.",
  },
];

const Services = () => {
  return (
    <section className="services" id="servicios">
      <div className="services__container">
        <div className="services__top">
          <span className="services__eyebrow">Servicios</span>

          <div className="services__heading">
            <h2 className="services__title">
              Soluciones en vidrio y aluminio para espacios residenciales y comerciales
            </h2>

            <p className="services__intro">
              Integramos diseño, funcionalidad y materiales de alta calidad para
              desarrollar proyectos que se adaptan a cada espacio, necesidad y estilo
              arquitectónico.
            </p>
          </div>
        </div>

        <div className="services__grid">
          {servicesData.map((service) => (
            <article className="services__card" key={service.number}>
              <div className="services__card-top">
                <span className="services__card-number">{service.number}</span>
                <span className="services__card-line"></span>
              </div>

              <h3 className="services__card-title">{service.title}</h3>
              <p className="services__card-description">{service.description}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services;